import useSWR from "swr";
import { fetcher } from "lib/actions/fetcher";
import { Project } from "lib/types/Project";
import { useRouteParamNumber } from "./useRouteParam";
import { endpoints } from "../actions/endpoints/endpoints";
import { ErrorBoundaryCause } from "components/error-boundaries/ErrorBoundaryCause";

export function useProject(projectId: number) {
  const {
    data: project,
    isLoading,
    error,
    mutate,
  } = useSWR<Project>(
    projectId ? endpoints.projectById(projectId) : null,
    fetcher,
  );

  if (error?.response?.status === 403) {
    throw new Error("Not authorized to access project.", {
      cause: ErrorBoundaryCause.ProjectAccessDenied,
    });
  }

  if (error?.response?.status === 404) {
    throw new Error("Project does not exist.", {
      cause: ErrorBoundaryCause.ProjectDoesNotExist,
    });
  }

  return {
    project,
    isLoading,
    error,
    mutate,
  };
}

export function useCurrentProject() {
  const projectId = useCurrentProjectId();
  const project = useProject(projectId);

  return {
    projectId,
    isProjectOpen: projectId != null,
    ...project,
  };
}

export function useCurrentProjectId(): number | null {
  const [id] = useRouteParamNumber("projectId");
  return id;
}
